import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContactInfluencedCampaigns } from './hooks/useContactInfluencedCampaigns';
import ContactCampaignCardAction from './ContactCampaignCardAction';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import EmptyStateWithIllustration from '../../../components/content/EmptyStateWithIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactCampaignCardEmptyState = ({
  objectId
}) => {
  const {
    hasData,
    loading
  } = useContactInfluencedCampaigns(objectId);
  if (loading) {
    return null;
  }
  if (hasData) {
    return /*#__PURE__*/_jsx(EmptyStateWithIllustration, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.emptyState.CAMPAIGN.influenced"
      })
    });
  }
  return /*#__PURE__*/_jsx(EmptyStateWithIllustration, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "cardAssociatedObjects.emptyState.CAMPAIGN.default_jsx",
      elements: {
        ContactCampaignCardAction: () => /*#__PURE__*/_jsx(ContactCampaignCardAction, {
          assetId: objectId
        })
      }
    })
  });
};
export default ContactCampaignCardEmptyState;